module.exports = __webpack_public_path__ + "static/media/activity-empty-state.cb1def5c.png";